import { MapPin, MessageCircle } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Eyebrow } from "./common";
import { wa } from "../lib/site";

const regionMsgKey = {
    sp: "São Paulo (Capital / Grande SP)",
    abc: "ABC Paulista",
    baixada: "Baixada Santista",
    interior: "Interior Paulista",
};

export default function Coverage() {
    const { lang, t } = useLang();

    const ask = (regionName) =>
        wa(
            lang === "pt"
                ? `Olá! Gostaria de saber se a ANG atende na região: ${regionName}. Gostaria de um orçamento.`
                : `Hi! I'd like to know if ANG covers this region: ${regionName}. I'd like a quote.`
        );

    return (
        <section id="cobertura" className="relative py-24 md:py-32 overflow-hidden">
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <Reveal className="mb-14 max-w-2xl">
                    <Eyebrow>{t.coverage.eyebrow}</Eyebrow>
                    <h2 className="mt-4 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
                        {t.coverage.title}
                    </h2>
                    <p className="mt-4 text-slate-400">{t.coverage.sub}</p>
                </Reveal>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {t.coverage.regions.map((r, i) => (
                        <Reveal key={r.id} delay={i * 0.1} className="h-full">
                            <a
                                data-testid={`coverage-region-tab-${r.id}`}
                                href={ask(regionMsgKey[r.id])}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group h-full flex flex-col rounded-2xl border border-white/10 bg-surface/60 p-7 hover:border-volt/50 hover:bg-surface transition-all hover:-translate-y-1.5"
                            >
                                <span className="font-mono text-[10px] text-slate-500">
                                    0{i + 1}
                                </span>
                                <span className="mt-4 w-11 h-11 rounded-xl bg-volt/10 border border-volt/25 flex items-center justify-center group-hover:bg-volt group-hover:text-obsidian text-volt transition-colors">
                                    <MapPin className="w-5 h-5" />
                                </span>
                                <h3 className="mt-5 font-display font-bold text-xl">
                                    {r.name}
                                </h3>
                                <p className="mt-2.5 text-sm text-slate-400 leading-relaxed flex-1">
                                    {r.desc}
                                </p>
                                <span className="mt-6 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-volt">
                                    <MessageCircle className="w-3.5 h-3.5" />
                                    {t.coverage.cta}
                                </span>
                            </a>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
